import React, { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { HasSidebarLayout, EntityHeader, DataLoad } from 'src/components'
import { UserContractorEditForm, UserContractorEditState } from 'src/components/forms/userContractor/edit'
import { useUserContractorRequest, useEditUserContractorRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'

const UserContractorEdit: FC = () => {
  const addMessage = useAddPopupMessage()
  const navigate = useNavigate()
  const params = useParams()
  const { userContractorId } = params as { id: string; userContractorId: string }
  const ucId = parseInt(userContractorId, 10)

  const { data: userContractor, isInitialLoading, isError, error } = useUserContractorRequest({
    userContractorId: ucId
  })

  document.title = `CLīMIT Admin Panel - Edit User Contractor ${userContractor?.name || ''}`

  const editRequest = useEditUserContractorRequest({
    options: {
      onSuccess: () => {
        navigate(-1)
      },
      onError: ({ message: text }) => {
        addMessage({ text, type: 'error' })
      }
    }
  })

  const onSubmit = (data: UserContractorEditState) => {
    editRequest.mutate({
      userContractorId: ucId,
      body: {
        name: data.name,
        email: data.email,
        roleId: data.roleId
      }
    })
  }

  return (
    <HasSidebarLayout>
      <DataLoad isLoading={isInitialLoading} isError={isError} errorMessage={error?.message}>
        <EntityHeader title={`Edit User Contractor: ${userContractor?.name || ''}`} />
        {userContractor && (
          <UserContractorEditForm
            initialValues={userContractor}
            isLoading={editRequest.isLoading}
            onSubmit={onSubmit}
          />
        )}
      </DataLoad>
    </HasSidebarLayout>
  )
}

export default UserContractorEdit
